import { ViolationError } from '@sweetspot/shared/types'

export const isAPhoneNumber = (string: string) => {
  if (!string) return true
  else {
    const re = /^\+(?:[0-9] ?){6,14}[0-9]$/

    return re.test(String(string))
  }
}

export const validateEmail = (email: string) => {
  if (!email) return true
  else {
    const re =
      // eslint-disable-next-line
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    return re.test(String(email).toLowerCase())
  }
}

export const isGolfId = (golfId: string) => {
  const re = /^\d{6}-\d{3}$/
  return re.test(golfId)
}

export const isInteger = (number: string | number) => {
  const re = /^[0-9]+$/
  return re.test(`${number}`)
}

export const isViolationError = (
  error: { error: string } | ViolationError
): error is ViolationError => 'violations' in error

export const isSwedishPhoneNumber = (phone: string) => {
  return String(phone).startsWith('+46')
}

export const isUKPhoneNumber = (phone: string) => {
  return String(phone).startsWith('+44')
}
